import { memo } from 'react';
import { Avatar } from '../Avatar';
import { jsx as _jsx } from "react/jsx-runtime";
function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}
const MemoizedUploaderAvatar = ({
  imageBuffer,
  lookup
}) => {
  if (!imageBuffer) {
    return /*#__PURE__*/_jsx(Avatar, {
      lookup: lookup,
      size: "xl"
    });
  }
  return /*#__PURE__*/_jsx(Avatar, {
    size: "xl",
    src: `data:image/png;base64,${arrayBufferToBase64(imageBuffer)}`
  });
};
export const UploaderAvatar = /*#__PURE__*/memo(MemoizedUploaderAvatar);